import { Center, RingProgress, Text } from '@mantine/core'

interface Props {
  value: number
  percentage: number
  color: string
}
export const CircularChart =
  ({ value, percentage, color }: Props) =>
  () => {
    return (
      <Center mt={10}>
        <RingProgress
          size={100}
          roundCaps
          thickness={8}
          sections={[{ value, color }]}
          style={{
            '--rp-size': '100px',
          }}
          label={
            <Center>
              <Text fw={700} fz='xl' c='gray.7'>
                {percentage}%
              </Text>
            </Center>
          }
        />
      </Center>
    )
  }
